module.exports = __webpack_public_path__ + "img/weichat.5a60a580.png";